import React, { useState } from 'react';
import Section from '../Section/Section';
import { personalInfo } from '../../data/portfolioData';
import './Resume.css';

/**
 * The resume is shown as a rendered page rather than an embedded PDF
 * viewer, so it sits on the same paper as the rest of the site. The
 * PDF itself is one click away. Regenerate the render with:
 *   qlmanage -t -s 1700 -o /tmp public/resume.pdf
 *   cp /tmp/resume.pdf.png public/resume-page.png
 */
export const Resume = () => {
  const [state, setState] = useState('loading');

  return (
    <Section id="resume" path="resume.pdf" title="Resume">
      <div className="resume-grid">
        <div className="resume-actions">
          <a className="action action-solid" href={personalInfo.resume} download="Chirag-Patil-Resume.pdf">
            Download PDF
          </a>
          <a className="action" href={personalInfo.resume} target="_blank" rel="noreferrer">
            Open in a new tab
          </a>
        </div>

        <figure className="resume-frame">
          <div className="resume-sheet">
            {state === 'loading' && (
              <div className="resume-skeleton" aria-hidden="true">
                <div className="skeleton resume-skeleton-title" />
                <div className="skeleton skeleton-line" style={{ width: '38%' }} />
                <div className="skeleton resume-skeleton-gap" />
                <div className="skeleton skeleton-line" style={{ width: '96%' }} />
                <div className="skeleton skeleton-line" style={{ width: '89%' }} />
                <div className="skeleton skeleton-line" style={{ width: '93%' }} />
                <div className="skeleton resume-skeleton-gap" />
                <div className="skeleton skeleton-line" style={{ width: '72%' }} />
                <div className="skeleton skeleton-line" style={{ width: '91%' }} />
                <div className="skeleton skeleton-line" style={{ width: '85%' }} />
                <div className="skeleton skeleton-line" style={{ width: '58%' }} />
              </div>
            )}

            {state !== 'failed' && (
              <img
                className="resume-page"
                src="/resume-page.png"
                width="1313"
                height="1700"
                alt="Resume of Chirag Patil, one page, covering education, skills, experience, projects, and certifications."
                decoding="async"
                onLoad={() => setState('ready')}
                onError={() => setState('failed')}
                data-state={state}
              />
            )}

            {state === 'failed' && (
              <p className="resume-fallback">
                The preview could not load.{' '}
                <a className="link" href={personalInfo.resume} target="_blank" rel="noreferrer">
                  Open the PDF instead
                </a>
                .
              </p>
            )}
          </div>
        </figure>
      </div>
    </Section>
  );
};

export default Resume;
